import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import RenunciaReceitaListar from '../../components/renunciareceita/listar';


function RenunciaReceitaScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Renúncia de Receitas no Município de Macuco"/>
            <Header />
            <Container>
                <RenunciaReceitaListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RenunciaReceitaScreen;